import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { SectionExtracharges, SectionExtrachargesConsume, TypePublicationModel } from '@app/src/views/StepTwo/channelPublication';
import { CATEGORIES } from '@app/src/config/categories';
import { getStateConfig } from '@app/src/common/datePicker/state/calendar/constants';
import { setPriceTotalByChannel } from '@app/src/views/StepOne/form';
import { Wrapper } from './styled';

export const AnnouncementExtracharge: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { packageId } = useParams();
  // const printStorage = isClient && JSON.parse(sessionStorage.getItem('print'));

  const [isShowPhotoVignette, setIsShowPhotoVignette] = useState(false);
  const [priceExtracharge, setPriceExtracharge] = useState(0);
  const [priceIgvExtracharge, setPriceIgvExtracharge] = useState(0);
  const [availablePhotos, setAvailablePhotos] = useState(0);

  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const channelId = currentChannel && currentChannel.id;
  const extracharges = useSelector(state => state.extracharge.data[channelId]);
  const extraWords = useSelector(state => state.print.general.extraWords);
  const dateSelected = useSelector(state => state.calendar);
  let currentDateSelected = dateSelected[getStateConfig[channelId]];
  const typeUserAction = useSelector(state => state.session.user.pasarella);

  useEffect(() => {
    if (!currentChannel) {
      if (typeUserAction === 'consume-print') {
        history.push(`${CATEGORIES.inmueble.paths.consumePackage.stepTypePublication}/${packageId}`);
      } else if (typeUserAction === 'purchase-print') {
        history.push(CATEGORIES.inmueble.paths.purchasePrint.stepTypePublication);
      } else {
        history.goBack();
      }
    }
  }, []);

  useEffect(() => {
    if (extracharges && extracharges.data && extracharges.data.length > 0) {
      let price = 0;
      let priceIgv = 0;
      extracharges.data.map((item) => {
        if (item.checked === true) {
          if (item.alias === 'palabra-extra') {
            price = price + (item.price * extraWords);
            priceIgv = priceIgv + (item.priceIgv * extraWords);
          } else {
            price = price + item.price;
            priceIgv = priceIgv + item.priceIgv;
          }
        }
        if (item.input === 'photoVignette') {
          setIsShowPhotoVignette(true);
          setAvailablePhotos(item.quantity);
        }
      });
      setPriceExtracharge(price);
      setPriceIgvExtracharge(priceIgv);
    }
  }, [extracharges]);

  useEffect(() => {
    dispatch(setPriceTotalByChannel(channelId,
      {
        price: (currentChannel && currentChannel.price + priceExtracharge) * (currentDateSelected && currentDateSelected.length),
        priceIgv: (currentChannel && currentChannel.priceIgv + priceIgvExtracharge) * (currentDateSelected && currentDateSelected.length)
      }));
  }, [priceIgvExtracharge, currentDateSelected, priceExtracharge, channelId]);

  const getPrice = (price) => {
    setPriceExtracharge(price.price)
    setPriceIgvExtracharge(price.priceIgv);
  };

  return (
    <Wrapper>
      {
        (typeUserAction === 'consume-print') ?
          <SectionExtrachargesConsume
            isShowPhotoUploader={isShowPhotoVignette}
            availablePhotos={availablePhotos}
            printDataId={channelId}
            getPrice={getPrice} />
          :
          <SectionExtracharges
            isShowPhotoUploader={isShowPhotoVignette}
            availablePhotos={availablePhotos}
            printDataId={channelId}
            getPrice={getPrice} />
      }
    </Wrapper>
  )
};